import { useEffect, useState } from "react";
import { getGlpiClient } from "../services/glpiClient";
import { resolveTechProfileIds } from "../services/outlookContext";
import { GlpiUser } from "../types/glpi";

export interface UseTechniciansResult {
  technicians: GlpiUser[];
  loading: boolean;
  error: string | null;
}

/** Charge les utilisateurs possédant le profil "Technicien". */
export function useTechnicians(enabled: boolean): UseTechniciansResult {
  const [technicians, setTechnicians] = useState<GlpiUser[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) return;
    const client = getGlpiClient();
    if (!client) return;

    let cancelled = false;
    setLoading(true);
    setError(null);
    client
      .listTechnicians(resolveTechProfileIds())
      .then((data) => {
        if (!cancelled) {
          // Tri par nom complet pour faciliter la recherche.
          const sorted = [...data].sort((a, b) => {
            const an = formatUser(a).toLowerCase();
            const bn = formatUser(b).toLowerCase();
            return an < bn ? -1 : an > bn ? 1 : 0;
          });
          setTechnicians(sorted);
        }
      })
      .catch((e: Error) => {
        if (!cancelled) setError(e.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { technicians, loading, error };
}

export function formatUser(u: { name: string; firstname?: string; realname?: string }): string {
  if (u.firstname || u.realname) {
    return `${u.firstname ?? ""} ${u.realname ?? ""}`.trim() || u.name;
  }
  return u.name;
}
